import { render } from "./NearbyLocalitiesFinder.vue?vue&type=template&id=79a8b485&scoped=true&ts=true"
import script from "./NearbyLocalitiesFinder.vue?vue&type=script&lang=ts"
export * from "./NearbyLocalitiesFinder.vue?vue&type=script&lang=ts"

import "./NearbyLocalitiesFinder.vue?vue&type=style&index=0&id=79a8b485&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a8b485"]])

export default __exports__